import { ServiceRequestRepository } from './ServiceRequestInvoiceSettlementRepository'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequestInvoiceSettlementController {
  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestInvoiceSettlementController', new ServiceRequestInvoiceSettlementController())
  }

  async loadInvoiceSettlementConsumerUnit (consumerUnit) {
    return ServiceRequestRepository.loadInvoiceSettlementConsumerUnit(consumerUnit)
  }

  async loadDatatable () {
    var datatable = await ServiceRequestRepository.loadDatatable()
    datatable.columns.forEach(column => {
      column.sortable = true
    })
    return datatable
  }

  async loadDatatableModel (consumerUnit) {
    return await ServiceRequestRepository.loadDatatableModel({ consumerUnit })
  }

  async createdBillingExemption (consumerUnit) {
    return await ServiceRequestRepository.createdBillingExemption(consumerUnit)
  }

  async applyExemption (params) {
    return await ServiceRequestRepository.applyExemption(params)
  }

  async applyCancellation (params) {
    return await ServiceRequestRepository.applyCancellation(params)
  }

  async processInvoices (consumerUnit, concessionContractTariff, client) {
    return await ServiceRequestRepository.processInvoices({ consumerUnit, concessionContractTariff, client })
  }

  async detail (nmInterface, params) {
    return await ServiceRequestRepository.detail(params)
  }

  async createBillingCancellation (consumerUnit) {
    return await ServiceRequestRepository.createBillingCancellation(consumerUnit)
  }

  async loadInvoicesByDate (params) {
    return await ServiceRequestRepository.loadInvoicesByDate(params)
  }
}
